<template>
    <div class="receipt-upload-input">
        <!-- 按鈕 ＆ 列表 -->
        <div>
            <input v-show="false" ref="fileInput" type="file" :accept="accept" @change="handleFileInputChange" />
            <div class="receipt-list">
                <ahReceiptItem
                    :data="item"
                    v-for="(item, index) in displayFileList"
                    :all-receipt="value"
                    :key="`${JSON.stringify(value)}-${index}`"
                    :cny="cny"
                    :editable="!disabled"
                    :isShowTaxStatus="isShowTaxStatus"
                    @edit="handleFileEditBtnClick(item)"
                    @delete="handleFileDeleteBtnClick(item)"
                    @declareStatusChange="onDeclareStatusChange"
                ></ahReceiptItem>
            </div>
            <el-button v-if="!disabled" :class="{ 'btn-space': !!displayFileList.length }" @click="handleUploadBtnClick" icon="el-icon-document-add"> 新增單據 </el-button>
        </div>
        <!-- 圖片編輯 -->
        <el-dialog
            :visible="imgCropModal.visible"
            :modal-append-to-body="false"
            :class="['receipt-upload-input-photo-upload-dialog', 'ah-detail-dialog']"
            top="6vh"
            append-to-body
            :before-close="imgCropModal_handleBeforeClose"
            :lock-scroll="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <template slot="title">
                <div>圖片編輯</div>
            </template>
            <div class="detail-row">
                <div class="detail-block">
                    <div class="img-cropper" style="max-width: 450px; margin: 0 auto">
                        <vue-cropper :zoomOnWheel="false" ref="cropper" :src="imgCropModal.imgSrc" :autoCropArea="1" :minCropBoxWidth="50" :minCropBoxHeight="50" preview=".preview" />
                    </div>
                    <div id="receipt-qrcode" style="opacity: 0; width: 1000px; position: absolute"></div>
                    <canvas id="qrcode-canvas" style="display: none"></canvas>
                    <center style="margin-top: 15px">
                        <el-button @click="openFileSelector">更換檔案</el-button>
                        <!-- <el-button @click="rotateLeft()" icon="el-icon-refresh-left"></el-button> -->
                        <!-- <el-button @click="rotateRight()" icon="el-icon-refresh-right"></el-button> -->
                        <el-button type="primary" @click="handleImgCropModalNextClick" :loading="imgCropModal.isLoading">下一步</el-button>
                    </center>
                </div>
            </div>
        </el-dialog>
        <!-- PDF 上傳 -->
        <el-dialog
            :visible="pdfUploadModal.visible"
            :modal-append-to-body="false"
            :class="['receipt-upload-input-pdf-dialog', 'ah-detail-dialog']"
            top="6vh"
            append-to-body
            :before-close="pdfUploadModal_handleBeforeClose"
            :lock-scroll="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <template slot="title">
                <div>PDF 檔案上傳</div>
            </template>
            <div class="detail-row">
                <div class="detail-block">
                    <center>
                        <ahFileIcon ext="pdf" />
                        <center>上傳中</center>
                    </center>
                    <center style="margin-top: 20px">
                        <el-button @click="pdfUploadModal_cancel">取消</el-button>
                    </center>
                </div>
            </div>
        </el-dialog>
        <!-- 單據編輯 -->
        <el-dialog
            :visible="receiptModal.visible"
            :modal-append-to-body="false"
            :class="{
                'receipt-upload-input-receipt-modal': true,
                'ah-detail-dialog': true,
                file: receiptModal.fileExt == 'pdf',
            }"
            top="6vh"
            append-to-body
            :before-close="onReceiptModalClose"
            :lock-scroll="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            @closed="onReceiptModalClosed"
        >
            <template slot="title">
                <div>單據編輯</div>
            </template>
            <div class="receipt-modal-layout">
                <div class="image-block" v-if="receiptModal.fileExt == 'jpg' || receiptModal.fileExt == 'jpeg' || receiptModal.fileExt == 'png'">
                    <el-image style="width: 100%" :src="receiptModal.form.filE_ATT" :previewSrcList="[receiptModal.form.filE_ATT]" v-if="receiptModal.form.filE_ATT"></el-image>
                    <div style="text-align: center; margin: 12px 0">
                        <el-button size="small" @click="receiptModal_handleReUploadBtnClick">更換檔案</el-button>
                    </div>
                </div>
                <div class="file-block" v-else-if="receiptModal.fileExt == 'pdf'">
                    <div class="file">
                        <ahFileIcon :ext="receiptModal.fileExt" :url="receiptModal.form.filE_ATT" />
                    </div>
                    <div style="text-align: center; margin: 12px 0">
                        <el-button size="small" @click="receiptModal_handleReUploadBtnClick">更換檔案</el-button>
                    </div>
                </div>
                <div v-else class="file-block" style="text-align: center">
                    <ahQrCodeUploader :visible="receiptModal.visible" @change="onQrCodeAttChange" />
                    <div class="or">or</div>
                    <div style="text-align: center; margin: 12px 0">
                        <el-button size="small" @click="openFileSelector"> 上傳檔案 (圖片、PDF檔) </el-button>
                        <div style="font-size: 12px; color: #aaa; margin-top: 3px">(檔案大小上限：25MB)</div>
                        <div v-if="[11].includes(receiptModal.form.filE_TYP)" class="upload-warning-card">
                            <div class="title">注意：高鐵電子車票證明</div>
                            <div class="description">由於「高鐵電子車票證明.pdf」為加密文件，將無法於列印時合併匯出，建議改以「台灣高鐵交易紀錄.pdf」或「上傳車票證明的"截圖"」檢附。</div>
                        </div>
                    </div>
                </div>
                <div class="form-block">
                    <el-form ref="receiptForm" :model="receiptModal.form" :label-position="isMobile() ? 'top' : 'right'" label-width="150px" v-loading="isLoading">
                        <el-form-item prop="filE_TYP" label="單據類型" :rules="receiptModal.rules.filE_TYP">
                            <el-select v-model="receiptModal.form.filE_TYP" @change="receiptModal_handleFileTypChange" placeholder="請選擇" no-data-text="無數據" style="width: 90%">
                                <el-option :label="item.value" v-for="item in attachmentTypeOptions" :key="item.key" :value="item.key" :disabled="cny !== 'TWD' && item.declareTax"></el-option>
                            </el-select>
                            <el-alert
                                v-if="[1, 2, 3, 10].includes(receiptModal.form.filE_TYP)"
                                type="warning"
                                :closable="false"
                                style="width: 90%; line-height: 100%; padding-top: 4px; margin-top: 5px"
                            >
                                <i class="el-icon-warning" style="position: relative; left: -8px"></i>
                                <span>請確定此發票有打公司統編！</span>
                            </el-alert>
                        </el-form-item>
                        <el-form-item prop="foO_DAT" label="單據日期" :rules="receiptModal.rules.foO_DAT">
                            <el-date-picker v-model="receiptModal.form.foO_DAT" type="date" value-format="timestamp" placeholder="選擇日期" @change="onCheckInvoiceDuplicate()"> </el-date-picker>
                        </el-form-item>
                        <el-form-item
                            prop="foo"
                            label="發票號碼"
                            v-if="[1, 2, 3, 10].includes(receiptModal.form.filE_TYP)"
                            :rules="[1, 2, 3, 10].includes(receiptModal.form.filE_TYP) ? receiptModal.rules.foo : [{ required: false }]"
                        >
                            <ahElInputInvoice v-model="receiptModal.form.foo" @input="onCheckInvoiceDuplicate()" />
                            <template v-if="isInvoiceInfoFulfill">
                                <i v-if="isCheckingInvoice" class="el-icon-loading" />
                                <template v-else>
                                    <i v-if="!isInvoiceUsed && !isInvoiceUsedBySelf" class="el-icon-check" />
                                    <div v-else-if="isInvoiceUsed" class="invoice-used-msg">本年度此發票號碼已存在於請款單： {{ isInvoiceUsed }}</div>
                                    <div v-else class="invoice-used-msg">此發票號碼已存在於本請款單</div>
                                </template>
                            </template>
                        </el-form-item>
                        <el-form-item v-if="isInvoiceInfoFulfill && [1, 2, 3, 10, 11].includes(receiptModal.form.filE_TYP) && isPayed('G03') && isAuth('G03')" prop="code" label="格式代號">
                            <span v-if="receiptModal.form.code">{{ receiptModal.form.code }}</span>
                            <i v-else-if="isCheckingInvoice" class="el-icon-loading" />
                            <span v-else style="color: red">請檢查發票號碼與單據日期</span>
                        </el-form-item>
                        <el-form-item
                            prop="foo"
                            label="票根號碼"
                            v-if="[11].includes(receiptModal.form.filE_TYP)"
                            :rules="[11].includes(receiptModal.form.filE_TYP) ? receiptModal.rules.ticket : [{ required: false }]"
                        >
                            <template slot="label">票根號碼（<el-button type="text" @click="receiptTrafficExampleDialog.visible = true">範例</el-button>)</template>
                            <el-input v-model="receiptModal.form.foo" :maxlength="20" :show-word-limit="true" @input="onCheckInvoiceDuplicate(true)" />
                            <template v-if="isInvoiceInfoFulfill">
                                <i v-if="isCheckingInvoice" class="el-icon-loading" />
                                <template v-else>
                                    <i v-if="!isInvoiceUsed && !isInvoiceUsedBySelf" class="el-icon-check" />
                                    <div v-else-if="isInvoiceUsed" class="invoice-used-msg">本年度此發票號碼已存在於請款單： {{ isInvoiceUsed }}</div>
                                    <div v-else class="invoice-used-msg">此發票號碼已存在於本請款單</div>
                                </template>
                            </template>
                        </el-form-item>
                        <el-form-item
                            prop="bsn"
                            label="賣方統編"
                            v-if="[1, 2, 3, 4, 10, 11].includes(receiptModal.form.filE_TYP)"
                            :rules="[1, 2, 3, 10, 11].includes(receiptModal.form.filE_TYP) ? receiptModal.rules.bsn : [{ required: false }]"
                        >
                            <div class="bsn-input-set">
                                <el-input v-model="receiptModal.form.bsn" @input="onBsnChange"></el-input>
                                <div class="response">
                                    <div v-if="isFetchingCmpName">
                                        <el-tooltip class="item" effect="light" content="查詢商工登記中..." placement="top">
                                            <i class="el-icon-loading" />
                                        </el-tooltip>
                                    </div>
                                    <div v-else-if="bsnCheckStatus > 0">
                                        <i class="el-icon-success" style="color: #25c700" />
                                    </div>
                                    <div v-else-if="bsnCheckStatus === 0">
                                        <el-tooltip class="item" effect="light" content="此統編查無公司登記資料，請再次確認" placement="top">
                                            <i class="el-icon-warning" style="color: #ec9600" />
                                        </el-tooltip>
                                    </div>
                                    <div v-else-if="bsnCheckStatus < 0">
                                        <el-tooltip class="item" effect="light" content="無法連線商工資料開放平臺，請手動輸入賣方公司名" placement="top">
                                            <i class="el-icon-warning" style="color: #ccc" />
                                        </el-tooltip>
                                    </div>
                                </div>
                            </div>
                            <div v-if="[11].includes(receiptModal.form.filE_TYP)">
                                <el-button size="mini" @click="applyBsn('16446274')">高鐵</el-button>
                                <el-button size="mini" @click="applyBsn('07524729')">台鐵</el-button>
                            </div>
                        </el-form-item>
                        <el-form-item prop="companyName" label="賣方公司名">
                            <el-autocomplete
                                class="inline-input"
                                v-model.trim="receiptModal.form.companyName"
                                :fetch-suggestions="receiptModal_queryCompanySearch"
                                :placeholder="isFetchingCmpName ? '搜尋中...' : '輸入公司名'"
                                :trigger-on-focus="false"
                                :maxlength="100"
                                :show-word-limit="true"
                                @select="receiptModal_handleCompanyNameSelect"
                                :rules="[4, 11].includes(receiptModal.form.filE_TYP) ? receiptModal.rules.companyName : [{ required: false }]"
                                style="width: 100%"
                                :disabled="isFetchingCmpName"
                            ></el-autocomplete>
                        </el-form-item>
                        <el-form-item prop="amt" :rules="[1, 2, 3, 4, 10, 11].includes(receiptModal.form.filE_TYP) ? receiptModal.rules.amt : [{ required: false }]">
                            <template slot="label"> 單據總額(含稅)<ahTip>注意，免稅商品不應計入單據總額。</ahTip> </template>
                            <money-input v-model="receiptModal.form.amt" :precision="cny == 'TWD' ? 0 : 2" style="width: 200px" @change="handleAmtChange" />
                            {{ cny }} <ahTip>使用請款相同幣別，如幣別不同請換算。</ahTip>
                        </el-form-item>
                        <el-form-item
                            prop="tax"
                            label="營業稅"
                            v-if="[1, 2, 3, 10, 11].includes(receiptModal.form.filE_TYP)"
                            :rules="[1, 3, 10, 11].includes(receiptModal.form.filE_TYP) ? receiptModal.rules.tax : [{ required: false }]"
                        >
                            <template slot="label">營業稅<ahTip>5%</ahTip></template>
                            <div style="display: flex">
                                <money-input v-model="receiptModal.form.tax" style="width: 150px" />
                            </div>
                        </el-form-item>
                        <el-form-item prop="before-tax" label="發票銷售額(未稅)" v-if="[1, 2, 3, 10, 11].includes(receiptModal.form.filE_TYP)">
                            <money-input :value="receiptModal.form.amt - receiptModal.form.tax" :disabled="true" style="width: 200px" />
                        </el-form-item>
                        <el-form-item prop="note" label="備註">
                            <el-input v-model="receiptModal.form.note" type="textarea" autosize :maxlength="100" :show-word-limit="true"> </el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <!-- Footer 功能按鈕 -->
            <div class="detail-row footer">
                <div style="text-align: center">
                    <el-button @click="receiptModal_handleCancelBtnClick">取消</el-button>
                    <el-button type="primary" class="primary-action" @click="receiptModal_handleSubmitBtnClick">確認</el-button>
                </div>
            </div>
        </el-dialog>
        <receipt-traffic-example-dialog :visible="receiptTrafficExampleDialog.visible" @close="receiptTrafficExampleDialog.visible = false" />
    </div>
</template>
<script>
import { attachmentTypes } from '@/assets/commonData/options.js';
import axios from 'axios';
import VueCropper from 'vue-cropperjs';
import ahFileIcon from '@/components/ui/ahFileIcon.vue';
import ahQrCodeUploader from '@/components/ui/ahQrCodeUploader.vue';
import ahReceiptItem from '@/components/ui/ahReceiptItem.vue';
import { isGuiNumberValid } from 'taiwan-id-validator';
import 'cropperjs/dist/cropper.css';
import ahElInputInvoice from '@/components/ui/ahElInputInvoice.vue';
import { Html5Qrcode } from 'html5-qrcode';
import moment from 'moment';
import _ from 'lodash';
import { checkFileSize } from '@/utils/fileValidator';
import invoiceSerialNumber from '@/assets/commonData/invoiceSerialNumber';
import ReceiptTrafficExampleDialog from './ReceiptTrafficExampleDialog.vue';

export default {
    name: 'receipt-upload-input',
    components: {
        VueCropper,
        ahFileIcon,
        ahQrCodeUploader,
        ahReceiptItem,
        ahElInputInvoice,
        ReceiptTrafficExampleDialog,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        cny: {
            type: String,
            default: 'TWD',
        },
        // File list
        value: {
            type: Array,
            default() {
                return [];
            },
        },
        vendorList: {
            type: Array,
            default: () => [],
        },
        vdrSno: {
            type: [Number, Boolean],
            default: null,
        },
        quality: {
            type: Number,
            default: 0.7,
        },
        maxWidth: {
            type: Number,
            default: 2048,
        },
        maxHeight: {
            type: Number,
            default: 2048,
        },
        accept: {
            type: String,
            default: 'image/png, image/jpeg, .pdf',
        },
        isShowTaxStatus: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        // 統一編號驗證
        const validateBsn = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('請輸入統一編號。'));
            } else if (!isGuiNumberValid(value, true)) {
                callback(new Error('統一編號格式不正確'));
            } else {
                callback();
            }
        };
        const invoiceValidate = (rule, value, callback) => {
            if (!value) callback(new Error('請填寫發票號碼'));
            else if (value.length < 10) callback(new Error('請輸入完整發票號碼'));
            callback();
        };

        return {
            bsnCheckStatus: null,

            isLoading: false,
            isCheckingInvoice: false,
            isInvoiceUsed: false,
            isInvoiceUsedBySelf: false,
            isFetchingCmpName: false,
            // buyerBsnWrongState: 0,

            cropImg: '',
            fileList: [],
            imgCropModal: {
                visible: false,
                isLoading: false,
                imgSrc: null,
            },
            pdfUploadModal: {
                visible: false,
                file: null,
            },
            imageViewer: {
                visible: false,
                srcList: [],
            },
            receiptModal: {
                visible: false,
                dataSource: null,
                fileExt: null,
                form: {
                    sno: null,
                    foo: '', // 發票號碼
                    foO_DAT: null, // 發票日期
                    bsn: '', // 統一編號
                    filE_ATT: '', // 檔案
                    filE_TYP: null, // 檢附單據類型
                    companyName: '', // 公司名稱
                    tax: 0, // 發票營業稅稅
                    amt: 0,
                    note: '', // 備註
                    delete: false,
                    code: null,
                },
                rules: {
                    filE_TYP: [
                        {
                            required: true,
                            message: '請選擇單據類型',
                            trigger: 'blur',
                        },
                    ],
                    foo: [
                        {
                            required: true,
                            validator: invoiceValidate,
                            trigger: 'blur',
                        },
                    ],
                    ticket: [
                        {
                            required: true,
                            message: '請輸入票根號碼',
                            trigger: 'blur',
                        },
                    ],
                    foO_DAT: [
                        {
                            required: true,
                            message: '請選擇發票日期',
                            trigger: 'change',
                        },
                    ],
                    companyName: [
                        {
                            required: true,
                            message: '請輸入公司名稱',
                            trigger: 'blur',
                        },
                    ],
                    bsn: [
                        {
                            required: true,
                            message: '請填寫統編',
                            trigger: 'blur',
                        },
                        { validator: validateBsn, trigger: 'blur' },
                    ],
                    tax: [
                        {
                            required: true,
                            message: '請填寫營業稅',
                            trigger: 'blur',
                        },
                    ],
                    amt: [
                        {
                            required: true,
                            message: '請輸入單據金額',
                            trigger: 'blur',
                        },
                    ],
                },
            },
            receiptTrafficExampleDialog: {
                visible: false,
            },
        };
    },
    computed: {
        headers() {
            return { Authorization: `Bearer ${localStorage.getItem('token')}` };
        },
        uploadFileActionUrl() {
            if (this.uploadFileType == 'PDF') {
                return `${process.env.VUE_APP_API_PATH}Tool/UploadPdf`;
            }
            return `${process.env.VUE_APP_API_PATH}Tool/UploadImg`;
        },
        attachmentTypeOptions() {
            return attachmentTypes;
        },
        inputVal: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
        displayFileList() {
            return this.inputVal.filter((x) => x.delete === false);
        },
        isInvoiceInfoFulfill() {
            return (
                (this.receiptModal.form.filE_TYP !== 11 && this.receiptModal.form.foo.length === 10 && this.receiptModal.form.foO_DAT)
                || (this.receiptModal.form.filE_TYP === 11 && this.receiptModal.form.foo.length > 0 && this.receiptModal.form.foO_DAT)
            );
        },
        companyBsn() {
            return this.$store.getters['menu/companyInfo'].bsn;
        },
        companyName() {
            return this.$store.getters['menu/companyInfo'].cH_CMP;
        },
    },

    mounted() {
        this.bsnCheckStatus = null;
        this.isFetchingCmpName = false;
    },

    methods: {
        onDeclareStatusChange(val) {
            this.$emit('declareStatusChange', val);
        },
        getFileExtByUrl(url) {
            return url.split('.').pop().toLowerCase();
        },

        handleUploadBtnClick() {
            // console.log('upload click');
            // this.openFileSelector();
            this.switchToReciptModal();
        },

        openFileSelector() {
            this.$refs.fileInput.click();
        },

        handleFileInputChange(event) {
            if (!event.target.files[0]) return;

            // 檢查檔案是否過大
            const fileSizeErrMsg = checkFileSize(event.target.files[0].size);
            if (fileSizeErrMsg) {
                this.$message({
                    showClose: true,
                    message: fileSizeErrMsg,
                    type: 'error',
                });
                return;
            }

            const fileExt = event.target.files[0].name.split('.').pop().toLowerCase();
            console.log('fileExt', fileExt);
            if (fileExt === 'jpeg' || fileExt === 'jpg' || fileExt === 'png') {
                this.handleNewImgFile(event.target.files[0]);
            } else if (fileExt === 'pdf') {
                this.handleNewPngFile(event.target.files[0]);
            }
        },

        handleNewImgFile(imgFile) {
            this.imgCropModal.visible = true;
            this.imgCropModal_setImage(imgFile);

            setTimeout(() => {
                this.scanQrcode(imgFile);
            }, 500);
        },

        scanQrcode(imgFile) {
            // 因掃描只能辨識一個qrcode，所以須先將右邊遮掉
            const qrarea = document.getElementById('receipt-qrcode');

            const cav = document.getElementById('qrcode-canvas');
            const ctx = cav.getContext('2d');

            const img = new Image();
            img.onload = () => {
                // 載入圖片
                cav.width = img.width;
                cav.height = img.height;
                ctx.drawImage(img, 0, 0);

                // 遮掉右半邊
                const helfWidth = img.width / 2;
                ctx.rect(helfWidth, 0, helfWidth, img.height);
                ctx.fillStyle = 'black';
                ctx.fill();

                fetch(cav.toDataURL())
                    .then((res) => res.blob())
                    .then((blob) => {
                        const file = new File([blob], 'dot.png', blob);
                        console.log(file);

                        // 開始辨識
                        qrarea.style.display = 'block';
                        const html5QrCode = new Html5Qrcode('receipt-qrcode');
                        html5QrCode
                            .scanFile(file, true)
                            .then((decodedText) => {
                                console.log(decodedText);
                                this.applyQrcodeInfo(decodedText);
                            })
                            .catch((err) => {
                                console.log(`Error scanning file. Reason: ${err}`);
                            })
                            .finally(() => {
                                qrarea.style.display = 'none';
                            });
                    });
            };
            img.src = URL.createObjectURL(imgFile);
        },

        applyQrcodeInfo(code) {
            // 電子發票格式：開頭兩碼大寫英文字母 + 八碼數字
            if (/^[A-Z]{2}\d{8}/.test(code)) {
                this.applyEInvoiceQrcodeInfo(code);
                return;
            }
            // 台鐵車票格式：開頭一碼大寫英文字母 + 九碼數字，並含有 ZZZZ 填充
            if (/^[A-Z]\d{9}/.test(code) && code.includes('ZZZZ')) {
                this.applyTRATicketQrcodeInfo(code);
            }
        },

        applyEInvoiceQrcodeInfo(code) {
            // 類型：電子發票(1)
            this.receiptModal.form.filE_TYP = 1;
            this.receiptModal_handleFileTypChange();

            // 發票號碼
            const foo = code.substring(0, 10);
            this.receiptModal.form.foo = foo;
            console.log('foo', foo);

            // 開立日期
            const year = parseInt(code.substring(10, 13), 10) + 1911;
            const month = parseInt(code.substring(13, 15), 10) - 1;
            const date = parseInt(code.substring(15, 17), 10);
            console.log('year', year);
            console.log('month', month);
            console.log('date', date);
            this.receiptModal.form.foO_DAT = new Date(year, month, date).getTime();

            // 檢查格式代號
            this.receiptModal.form.code = this.getPaymentValidateCode(this.receiptModal.form);

            // 稅金
            const noTaxPrice = parseInt(code.substring(21, 29), 16);
            const totalPrice = parseInt(code.substring(29, 37), 16);
            let tax = 0;
            if (noTaxPrice > 0) {
                tax = totalPrice - noTaxPrice;
            }
            console.log('tax', tax);
            console.log('total', totalPrice);
            this.receiptModal.form.tax = tax;
            this.receiptModal.form.amt = totalPrice;

            // 賣方統編
            const bsn = code.substring(45, 53);
            console.log('bsn', bsn);
            this.receiptModal.form.bsn = bsn;
            this.onBsnChange();

            // 檢查買方統編
            // const buyerBsn = code.substring(37, 45);
            // console.log('buyerBsn', buyerBsn);
            // this.validateBuyerBsn(buyerBsn);
        },

        applyTRATicketQrcodeInfo(code) {
            // 類型：載有稅額之其他憑證(11)
            this.receiptModal.form.filE_TYP = 11;
            this.receiptModal_handleFileTypChange();

            // 票根號碼（前15碼）
            this.receiptModal.form.foo = code.substring(0, 15);

            // 票價（未稅 pos 19-22，含稅 pos 23-26，十進位）
            const preTaxPrice = parseInt(code.substring(19, 23), 10);
            const totalPrice = parseInt(code.substring(23, 27), 10);
            console.log('tra preTaxPrice', preTaxPrice);
            console.log('tra totalPrice', totalPrice);
            if (!isNaN(totalPrice) && totalPrice > 0) {
                this.receiptModal.form.amt = totalPrice;
                if (!isNaN(preTaxPrice) && preTaxPrice > 0 && preTaxPrice < totalPrice) {
                    this.receiptModal.form.tax = totalPrice - preTaxPrice;
                } else {
                    this.handleAmtChange();
                }
            }

            // 台鐵統編
            this.applyBsn('07524729');
        },

        handleNewPngFile(pdfFile) {
            this.pdfUploadModal.visible = true;
            this.pdfUploadModal_upload(pdfFile);
        },

        handleImgCropModalNextClick() {
            this.imgCropModal_upload();
        },

        handleFileEditBtnClick(item) {
            console.log(item);
            this.receiptModal.dataSource = item;
            this.switchToReciptModal(item);
            this.onCheckInvoiceDuplicate(true);
        },

        async handleFileDeleteBtnClick(item) {
            try {
                await this.$confirm('確定要刪除單據？', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });
                item.delete = true;
                this.$emit('onSave');
            } catch (e) {
                console.log(e);
            }
        },

        handleAmtChange() {
            if (this.cny == 'TWD') {
                const rat = 1.05;
                this.receiptModal.form.tax = Math.round(this.receiptModal.form.amt - Math.round(this.receiptModal.form.amt / rat));
            }
        },

        switchToReciptModal(receiptData, receiptType) {
            // hide img crop modal
            this.resetImgCropModal();
            this.resetPdfUploadModal();

            // apply data
            if (receiptData) {
                for (const key in receiptData) {
                    this.receiptModal.form[key] = receiptData[key];
                }

                // fileType
                if (receiptData.filE_ATT && receiptData.filE_ATT.trim() != '') {
                    this.receiptModal.fileExt = receiptData.filE_ATT.split('.').pop().toLowerCase();
                    console.log('fileExt', this.receiptModal.fileExt);
                } else {
                    this.receiptModal.fileExt = null;
                }
            }
            this.onCheckInvoiceDuplicate();

            // apply receipt type name
            if (receiptType) {
                this.receiptModal.form.filE_TYP = receiptType;
                this.receiptModal_handleFileTypChange();
            }

            // show receipt modal
            this.receiptModal.visible = true;
            setTimeout(() => {
                this.$refs.receiptForm.clearValidate();
            }, 1);
        },

        imgCropModal_handleBeforeClose() {
            this.$emit('close', false);
            this.imgCropModal.visible = false;
            this.imgCropModal.isLoading = false;
            this.imgCropModal.imgSrc = null;
            this.$refs.fileInput.value = null;
        },

        imgCropModal_downloadFile() {
            const canvas = this.$refs.cropper.getCroppedCanvas({
                maxWidth: this.maxWidth,
                maxHeight: this.maxHeight,
            });
            const link = document.createElement('a');
            link.download = 'download.png';
            link.href = canvas.toDataURL('image/jpeg', this.quality);
            link.click();
            link.delete;
        },

        imgCropModal_setImage(file) {
            if (file.type.indexOf('image/') === -1) {
                alert('Please select an image file');
                return;
            }
            if (typeof FileReader === 'function') {
                const reader = new FileReader();
                reader.onload = (event) => {
                    this.imgCropModal.imgSrc = event.target.result;
                    // rebuild cropperjs with the updated source
                    this.$refs.cropper.replace(event.target.result);
                };
                reader.readAsDataURL(file);
            } else {
                alert('Sorry, FileReader API not supported');
            }
        },

        rotateLeft() {
            this.$refs.cropper.rotate(90);
        },

        rotateRight() {
            this.$refs.cropper.rotate(-90);
        },

        cropImage() {
            // get image data for post processing, e.g. upload or setting image src
            this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
        },

        dataURLtoFile(dataurl, filename) {
            const arr = dataurl.split(',');
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n) {
                u8arr[n - 1] = bstr.charCodeAt(n - 1);
                n -= 1; // to make eslint happy
            }
            return new File([u8arr], filename, { type: mime });
        },

        imgCropModal_upload() {
            this.imgCropModal.isLoading = true;

            // get image data
            const canvas = this.$refs.cropper.getCroppedCanvas({
                maxWidth: this.maxWidth,
                maxHeight: this.maxHeight,
            });

            const imgData = canvas.toDataURL('image/jpeg', this.quality);

            // formData
            const formData = new FormData();
            formData.append('uploadType', 1);
            formData.append('file', this.dataURLtoFile(imgData));

            // ajax post
            return axios
                .post(`${process.env.VUE_APP_API_PATH}Tool/UploadImg`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                    },
                })
                .then((resp) => {
                    console.log(resp);
                    if (this.receiptModal.form.filE_TYP) {
                        this.switchToReciptModal({ filE_ATT: resp.data.imgUrl });
                    } else {
                        this.switchToReciptModal({ filE_ATT: resp.data.imgUrl }, 3);
                    }
                })
                .catch(() => {
                    this.$message({
                        showClose: true,
                        message: '上傳失敗，請重新上傳。',
                        type: 'error',
                    });
                })
                .finally(() => {
                    this.imgCropModal.isLoading = false;
                });
        },

        pdfUploadModal_upload(pdfFile) {
            // formData
            const formData = new FormData();
            formData.append('uploadType', 1);
            formData.append('file', pdfFile);

            axios
                .post(`${process.env.VUE_APP_API_PATH}Tool/UploadPdf`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                    },
                })
                .then((resp) => {
                    console.log(resp);
                    this.switchToReciptModal({ filE_ATT: resp.data.url });
                })
                .catch(() => {
                    this.$message({
                        showClose: true,
                        message: '上傳失敗，請重新上傳圖片。',
                        type: 'error',
                    });
                })
                .finally(() => {
                    this.imgCropModal.isLoading = false;
                });
        },

        pdfUploadModal_cancel() {
            this.pdfUploadModal.visible = false;
        },

        pdfUploadModal_handleBeforeClose() {
            this.$emit('close', false);
            this.$refs.fileInput.value = null;
            this.pdfUploadModal.visible = false;
        },

        onReceiptModalClose() {
            this.$emit('close', false);
            this.receiptModal.visible = false;
        },
        onReceiptModalClosed() {
            this.resetReceiptModal();
        },

        receiptModal_handleReUploadBtnClick() {
            this.receiptModal.fileExt = null;
        },

        async receiptModal_handleFileTypChange() {
            if (this.receiptModal.form.filE_TYP === 11) this.receiptModal.form.code = 22;
            else this.onCheckInvoiceDuplicate();

            this.handleAmtChange();
            this.$refs.receiptForm.clearValidate();

            // 自動填入委外廠商名稱 & 統編
            if (!this.vdrSno) return; // 沒有委外廠商，不自動填入
            if (!!this.receiptModal.form.companyName || !!this.receiptModal.form.bsn) return; // 已有輸入公司名稱或統編，不自動填入

            // 取得所有委外廠商資料，自動填入名稱＆統編（委外個人不填，因為通常委外個人不會開發票）
            try {
                this.isLoading = true;
                const vendorInfo = await this.fetchVendorInfo(this.vdrSno);
                // 找到有統編的廠商，才自動填入，無統編的可能不是正式廠商，所以不填入
                if (vendorInfo && vendorInfo.bsn) {
                    this.receiptModal.form.companyName = vendorInfo.fnam;
                    if ([1, 2, 3, 4, 10, 11].includes(this.receiptModal.form.filE_TYP)) {
                        this.receiptModal.form.bsn = vendorInfo.bsn;
                    } else {
                        this.receiptModal.form.bsn = null;
                    }
                }
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },

        async receiptModal_queryCompanySearch(queryString, callback) {
            if (queryString === ' ') {
                callback([]);
                return;
            }
            const resp = await this.$api({
                url: '/PaymentManagenmentPage/QueryReciptFile',
                params: { keyword: queryString },
                method: 'GET',
            });

            if (resp.data.items.length > 0 || resp.data.paymentInvoiceItems.length > 0) {
                const list = [];
                const FULL_LIST = [...resp.data.items, ...resp.data.paymentInvoiceItems];

                FULL_LIST.forEach((receipt) => {
                    const searchKey = receipt.companyName ? 'companyName' : 'sellerName';
                    const FOUND = list.find((x) => x.value === receipt[searchKey]);

                    // 如果該公司名還沒有存在清單中
                    if (!FOUND) {
                        // 建立清單物件
                        list.push({
                            value: receipt[searchKey],
                            bsn: receipt.bsn,
                        });
                    }
                });
                callback(list);
            } else {
                callback([]);
            }
        },

        receiptModal_handleCompanyNameSelect(item) {
            this.receiptModal.form.bsn = item.bsn;
        },

        resetPdfUploadModal() {
            this.pdfUploadModal.visible = false;
            this.pdfUploadModal.file = false;
            this.$refs.fileInput.value = null;
        },
        resetImgCropModal() {
            this.imgCropModal.visible = false;
            this.imgCropModal.imgSrc = null;
            this.$refs.fileInput.value = null;
        },
        resetReceiptModal() {
            this.receiptModal.dataSource = null;
            this.receiptModal.form.sno = null;
            this.receiptModal.form.foo = '';
            this.receiptModal.form.foO_DAT = null;
            this.receiptModal.form.bsn = '';
            this.receiptModal.form.filE_ATT = '';
            this.receiptModal.form.filE_TYP = null;
            this.receiptModal.form.companyName = '';
            this.receiptModal.form.tax = 0;
            this.receiptModal.form.amt = 0;
            this.receiptModal.form.note = '';
            this.receiptModal.form.delete = false;
            this.receiptModal.form.code = null;

            this.receiptModal.fileExt = null;

            // this.$refs.receiptForm.resetFields()
            this.$refs.receiptForm.clearValidate();
            this.$refs.fileInput.value = null;
            this.isFetchingCmpName = false;
            this.bsnCheckStatus = null;
        },
        receiptModal_handleCancelBtnClick() {
            this.resetImgCropModal();
            this.onReceiptModalClose();
        },

        receiptModal_handleFileClick(fileUrl) {
            window.open(fileUrl, '_blank', 'toolbar=no, width=1300, height=900');
        },

        receiptModal_handleSubmitBtnClick() {
            // 驗證
            this.$refs.receiptForm.validate(async (valid) => {
                if (valid) {
                    try {
                        if ([1, 2, 3, 10].includes(this.receiptModal.form.filE_TYP) && !this.receiptModal.form.code) {
                            await this.$confirm('您輸入的發票號碼不存在於單據日期所屬營業稅申報期別，確定要儲存嗎？', {
                                confirmButtonText: '確定',
                                cancelButtonText: '取消',
                            });
                        }

                        // console.log('buyerBsnWrongState', this.buyerBsnWrongState);
                        // if ([1, 2, 3, 10].includes(this.receiptModal.form.filE_TYP) && this.buyerBsnWrongState !== 0) {
                        //     switch (this.buyerBsnWrongState) {
                        //     case 1:
                        //         await this.$confirm('此發票沒有買方統編，依法不可報帳，確定要檢附嗎？', {
                        //             confirmButtonText: '確定',
                        //             cancelButtonText: '取消',
                        //         });
                        //         break;
                        //     case 2:
                        //         await this.$confirm(`此發票買方統編不是${this.companyName}公司統編，依法不可報帳，確定要檢附嗎？`, {
                        //             confirmButtonText: '確定',
                        //             cancelButtonText: '取消',
                        //         });
                        //         break;
                        //     default:
                        //     }
                        // }

                        // 稅金不可含小數點
                        this.receiptModal.form.tax = Math.round(this.receiptModal.form.tax);

                        // 非電子發票、二聯式、三聯式、載有稅額之其他憑證，沒有稅金、單據號碼
                        if (![1, 2, 3, 10, 11].includes(this.receiptModal.form.filE_TYP)) {
                            this.receiptModal.form.foo = '';
                            this.receiptModal.form.tax = 0;
                        }

                        if (this.receiptModal.dataSource) {
                            // edit
                            // apply new data
                            for (const key in this.receiptModal.form) {
                                this.receiptModal.dataSource[key] = this.receiptModal.form[key];
                            }
                        } else {
                            // new
                            this.inputVal.push(JSON.parse(JSON.stringify(this.receiptModal.form)));
                        }

                        this.resetImgCropModal();
                        this.onReceiptModalClose();
                        this.$emit('onSave');
                    } catch (e) {
                        console.log(e);
                    }
                }
            });
        },

        async onCheckInvoiceDuplicate(skipCheckCode) {
            if (this.isInvoiceInfoFulfill && !this.isCheckingInvoice && this.receiptModal.form.foo && this.receiptModal.form.foO_DAT) {
                try {
                    this.isCheckingInvoice = true;
                    const resp = await this.$api({
                        url: '/PaymentManagenmentPage/QueryReciptFile',
                        params: {
                            foo: this.receiptModal.form.foo,
                            year: moment(this.receiptModal.form.foO_DAT).year(),
                        },
                        method: 'GET',
                    });

                    // 檢查不包含本請款單之其他請款單
                    const exceptThisList = [...resp.data.items];
                    this.value.forEach((item) => {
                        const FOUND = resp.data.items.findIndex((o) => o.sno === item.sno);
                        if (FOUND >= 0) exceptThisList.splice(FOUND, 1);
                    });
                    this.isInvoiceUsed = _.chain(exceptThisList).map('payoo').uniq().value()
                        .join('、');

                    // 檢查本請款單
                    const thisList = _.chain(this.value)
                        .filter((o) => o.sno !== this.receiptModal.dataSource?.sno)
                        .find((o) => o.foo === this.receiptModal.form.foo)
                        .value();
                    this.isInvoiceUsedBySelf = !!thisList;

                    // 自動格式代號
                    if (!skipCheckCode) this.receiptModal.form.code = this.getPaymentValidateCode(this.receiptModal.form);
                } finally {
                    this.isCheckingInvoice = false;
                }
            }
        },
        onQrCodeAttChange(url, meta) {
            this.receiptModal.fileExt = url.split('.').pop().toLowerCase();
            this.receiptModal.form.filE_ATT = url;

            // 有辨識到的資料才取代，其他保留
            if (meta.foo) this.receiptModal.form.foo = meta.foo;
            if (meta.foO_DAT) this.receiptModal.form.foO_DAT = meta.foO_DAT;
            if (meta.filE_TYP) this.receiptModal.form.filE_TYP = meta.filE_TYP;
            if (meta.tax) this.receiptModal.form.tax = meta.tax;
            if (meta.amt) this.receiptModal.form.amt = meta.amt;
            if (meta.bsn) {
                this.receiptModal.form.bsn = meta.bsn;
                this.onBsnChange();
            }
            if (meta.foo && meta.foO_DAT) this.onCheckInvoiceDuplicate();
            // if (meta.buyerBsn) this.validateBuyerBsn(meta.buyerBsn);
        },
        // 檢查買方統編
        // validateBuyerBsn(buyerBsn) {
        //     if (!buyerBsn || buyerBsn === '00000000' || buyerBsn === '') this.buyerBsnWrongState = 1;
        //     else if (buyerBsn !== `${this.companyBsn}`) this.buyerBsnWrongState = 2;
        //     else this.buyerBsnWrongState = 0;
        // },
        // 取得委外廠商
        async fetchVendorList() {
            const resp = await this.$api({
                url: '/PaymentManagenmentPage/GetOutsourcingList?VDR_TYP=VD&PageSize=999&PageNum=1',
                method: 'GET',
            });
            return resp.data.items;
        },

        // 取得單筆委外廠商
        async fetchVendorInfo(sno) {
            const resp = await this.$api({
                url: '/PaymentManagenmentPage/GetVendorOutsourcing',
                params: { sno },
                method: 'GET',
            });
            return resp.data.item;
        },

        getPaymentValidateCode(item) {
            // if (item.typ < 0) return undefined;
            if (item.filE_TYP === 11) return 22;

            const isIncome = false;
            const fooMonth = moment(item.foO_DAT).month() + 1;
            const fooYear = moment(item.foO_DAT).year();
            const fooKey = `${item.foo[0]}${item.foo[1]}`;
            const TYPE = _.chain(invoiceSerialNumber)
                .filter(['year', fooYear])
                .find((o) => o.month.includes(fooMonth))
                .get('datas')
                .find((o) => o.serialNumbers.includes(fooKey))
                .get('name')
                .value();

            const isCashierTripleInvoice = item.filE_TYP === 10;
            const TYPE_CODE = { A: 1, B: 2, D: 5 };
            if (TYPE) return Number(`${isIncome ? 3 : 2}${isCashierTripleInvoice ? 5 : TYPE_CODE[TYPE]}`);

            return null;
        },

        async onBsnChange() {
            const { bsn } = this.receiptModal.form;
            if (bsn && bsn.length === 8) {
                this.isFetchingCmpName = true;
                try {
                    const resp = await this.$api({
                        url: '/PaymentManagenmentPage/GetCompanyName',
                        params: { bsn },
                        method: 'GET',
                    });
                    if (resp.data.companyName) this.receiptModal.form.companyName = resp.data.companyName;
                    this.bsnCheckStatus = resp.data.status;
                } catch (error) {
                    console.log(error);
                } finally {
                    this.isFetchingCmpName = false;
                }
            } else if (bsn.length < 8) {
                this.isFetchingCmpName = false;
                this.bsnCheckStatus = null;
            }
        },
        applyBsn(bsn) {
            this.receiptModal.form.bsn = bsn;
            this.onBsnChange();
            this.$nextTick(() => {
                this.$refs.receiptForm.clearValidate();
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.invoice-used-msg {
    line-height: 2;
    margin-top: 5px;
    font-size: 9pt;
    color: red;
}
.btn-space {
    margin-top: 20px;
}
</style>
<style lang="scss">
.receipt-upload-input-photo-upload-dialog.ah-detail-dialog {
    .el-dialog {
        max-width: 700px;
        min-height: 300px;
    }
}

.receipt-upload-input-pdf-dialog.ah-detail-dialog {
    .el-dialog {
        max-width: 300px;
        min-height: 200px;
    }
}

.receipt-upload-input-receipt-modal.ah-detail-dialog {
    padding: 0 10px;

    .el-dialog {
        max-width: 1300px;
        min-height: 300px;
    }

    &.file {
        .el-dialog {
            max-width: 830px;
        }
    }

    .receipt-modal-layout {
        display: block;
        width: 100%;

        @media (min-width: 992px) {
            display: table;
        }

        .file-block {
            display: block;
            height: 100%;
            background-color: #f6f6f6;
            padding: 25px;

            @media (min-width: 992px) {
                display: table-cell;
                vertical-align: top;
                height: 100%;
                position: relative;
                vertical-align: middle;
            }
        }

        .image-block {
            display: block;
            background-color: #f6f6f6;
            padding: 25px;

            @media (min-width: 992px) {
                display: table-cell;
                vertical-align: top;
                height: 100%;
                position: relative;
                vertical-align: middle;
            }

            .el-image {
                img {
                    object-fit: contain;
                    max-height: 500px;
                }
            }
        }

        .form-block {
            display: block;
            padding: 25px;
            width: 550px;

            @media (max-width: 720px) {
                width: 100%;
            }

            @media (min-width: 992px) {
                display: table-cell;
                vertical-align: top;
            }
        }
    }
    .or {
        margin: 0 auto;
        color: #888;
        font-size: 10pt;
        // border-top: 1px solid #ccc;
        max-width: 200px;
    }

    .bsn-input-set {
        display: grid;
        grid-template-columns: auto 50px;
        gap: 10px;
    }
    .upload-warning-card {
        color: #d37f00;
        background-color: #fdf6ec;
        border: 1px solid #edc992;
        border-radius: 5px;
        font-size: 10pt;
        padding: 10px 20px;
        margin: 15px;

        > .title {
            font-weight: bold;
            margin-bottom: 10px;
        }
    }
}
</style>
